import { orderAndProceduresDataToStaffUsers, bookingsDataToPatients } from '@caresend/utils';
import { hasMutation, customCommit } from '../helpers.js';

const setStaffUsers = (
/** Optional mutations require type casting */
commit, proceduresWithData, orderDataArray, store, additionalStaffUsers) => {
    /** Staff Users (Nurses, Prescribers) */
    let staffUsersSet = 'N/A';
    let staffUsers;
    if (hasMutation(store, 'users/SET_STAFF_USERS')) {
        const staffUsersObj = orderAndProceduresDataToStaffUsers(orderDataArray, proceduresWithData);
        staffUsers = Object.values({ ...staffUsersObj, ...additionalStaffUsers });
        staffUsersSet = staffUsers.length;
        customCommit(commit, 'users/SET_STAFF_USERS', { staffUsers });
    }
    return { staffUsersSet, staffUsers };
};
const setUsers = (
/** Optional mutations require type casting */
commit, bookingsWithData, store) => {
    /** Staff Users (Nurses, Prescribers) */
    let usersSet = 'N/A';
    let users;
    if (hasMutation(store, 'users/SET_USERS')) {
        const usersObj = bookingsDataToPatients(bookingsWithData);
        users = Object.values(usersObj);
        usersSet = users.length;
        customCommit(commit, 'users/SET_USERS', users);
    }
    return { usersSet, users };
};

export { setStaffUsers, setUsers };
